export enum ConfigSettings {
	ShowTimeCodeInClearCodeTab = 'ShowTimeCodeInClearCodeTab',
	ShowProvisionTab = 'ShowProvisionTab',
	Disable_Edit_TimeEntry_OnCleared_Appt = 'Disable_Edit_TimeEntry_OnCleared_Appt',
	Enable_Inventory_Removal_Reason = 'Enable_Inventory_Removal_Reason',
	UseTruck = 'UseTruck',
	Disable_Warehouse_Validation = 'Disable_Warehouse_Validation',
	Allow_Inventory_Mode_Switch = 'Allow_Inventory_Mode_Switch',
	ShowPlantTab = 'ShowPlantTab',
}
